<mat-form-field [hideRequiredMarker]="frmGroup.get(this.configData.name)['hidden']" [hidden]="frmGroup.get(this.configData.name)['hidden']" fxFlex="0 0 100%" appearance="outline" [formGroup]="frmGroup"  color="accent"> 
  <mat-label>{{ configData.label }}</mat-label>
  <mat-select    
    [formControlName]="configData.name"
    [required]="configData.required"
    [compareWith]="compare" 
    (selectionChange)="manageDropdown($event, $event.value)"
  >
  <mat-option *ngFor="let dropDownListItem of dropDownListItems" [disabled]="dropDownListItem.disabled?dropDownListItem.disabled:false" [value]="dropDownListItem">
      {{dropDownListItem.displayValue}}
    </mat-option>
  </mat-select>

  <mat-error *ngIf="frmGroup.get(configData.name).errors">
    <mat-error *ngIf="frmGroup.get(configData.name).errors.required">      
      Required
    </mat-error>
  </mat-error>  
</mat-form-field>
